import type { Bol, VerifyRouteStopBol } from "@/api/trips/dto/trip.dto";

export function getStopSignature(bol: Bol, stopId: string): Record<string, string> {
  return stopId in bol.signedBy ? { [stopId]: bol.signedBy[stopId] } : {};
}

export function toVerifyBol(bol: Bol, stopId: string): VerifyRouteStopBol {
  return {
    id: bol.id,
    orderId: bol.orderId,
    routeStopId: bol.routeStopId,
    number: bol.number,
    isDeleted: bol.isDeleted,
    signedBy: getStopSignature(bol, stopId),
  };
}
